import { Type } from "@sinclair/typebox";
export const IdSchema = Type.String({
    minLength: 1,
    maxLength: 128,
    pattern: "^[A-Za-z0-9][A-Za-z0-9._:-]*$",
});
export const Sha256Schema = Type.String({ pattern: "^[a-f0-9]{64}$" });
export const TimestampSchema = Type.String({ format: "date-time" });
export const NonNegativeIntegerSchema = Type.Integer({ minimum: 0 });
export const PositiveIntegerSchema = Type.Integer({ minimum: 1 });
// 线协议先经过 JSON 解码，因此容器内部天然只能继续包含 JSON 值。这里约束顶层种类，
// 深层有限性与普通对象原型由 canonicalJson/isJsonValue 在摘要边界再次验证；避免在多个
// 字段内嵌同名递归 $id，确保生成 schema 可被标准 JSON Schema 2020-12 validator 编译。
const JsonValueRuntimeSchema = Type.Union([
    Type.Null(),
    Type.Boolean(),
    Type.Number(),
    Type.String(),
    Type.Array(Type.Unknown()),
    Type.Record(Type.String(), Type.Unknown()),
]);
export const JsonValueSchema = JsonValueRuntimeSchema;
//# sourceMappingURL=shared.js.map